import React from "react";
import { Section } from "./Elements/Section";
import { Card } from "./Elements/Card";
import { COLOR_PRIMARY, COLOR_ACCENT } from "../config/Constants";

const caseStudies = [
  {
    logo: "🌍",
    title: "Global Travel SaaS",
    impact: ["99.95% uptime", "40% faster search", "ISO 27001 prep"],
    blurb:
      "Re‑architected search & booking platform on GCP with IaC, tracing, and canary deploys.",
  },
  {
    logo: "💳",
    title: "Fintech KYC Engine",
    impact: ["3x throughput", "<200ms P95", "SOC2 ready"],
    blurb:
      "Built streaming KYC microservices with Kafka, rules engine, and secure data vaults.",
  },
  {
    logo: "🛒",
    title: "Headless Commerce",
    impact: ["+18% conversion", "Core Web Vitals green", "Global CDN"],
    blurb:
      "Next.js storefront with edge rendering, A/B tests, and analytics pipeline.",
  },
];

export const Work = () => {
  return (
    <Section
      id="work"
      eyebrow="Proof"
      title="Selected Work"
      subtitle="Outcomes we’re proud of. More references available on request."
    >
      <div className="grid md:grid-cols-3 gap-6">
        {caseStudies.map((c) => (
          <Card key={c.title}>
            <div className="flex items-center gap-3">
              <div className="text-2xl">{c.logo}</div>
              <h3 className="font-semibold text-gray-900">{c.title}</h3>
            </div>
            <p className="mt-2 text-sm text-gray-600">{c.blurb}</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {c.impact.map((tag) => (
                <span
                  key={tag}
                  className="text-xs rounded-full bg-indigo-50 text-indigo-700 px-2 py-1 font-semibold"
                  style={{
                    backgroundColor: `${COLOR_ACCENT}22`,
                    color: COLOR_PRIMARY,
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          </Card>
        ))}
      </div>
    </Section>
  );
};
